module.exports = __webpack_public_path__ + "static/media/news-david.2f81c0cb.jpg";